import React from 'react'

type Props = {
    hideIcon    : boolean
    hidePopover : {():void}
    onClick?    : func
}

export default function ExportToPdfOption(props:Props) {

    const isPro = gd.session.companies.get(gd.companyId).license.isPro;

    const onClick = () => {
        const app:any = gd.getApp()
        if (props.onClick) {
            props.onClick()
        } else {
            app.importExport.exportToPdf()
        }

        props.hidePopover()
    };

    const onClickUpgrade = () => {
        gd.modals.other.upgradeToPro(gd.companyId);
        props.hidePopover();
    };

    return (
        <div className="option with-icon" onClick={isPro ? onClick : onClickUpgrade}>
            <div className={Classes('ico', {'i5-pdf': !props.hideIcon})}/>
            <div className="label">Export to PDF</div>
            {!isPro && <div className="ui5-ico-pro"/>}
        </div>
    )
}